<div class="container py-4">

  <!-- 🔷 TÍTULO -->
 

  <!-- 🟥 BANNER -->
  <div class="banner-ia">
    <div class="banner-left">
      <img src="assets/banners_carreras/FERROVIARIA.jpg" alt="IA">
    </div>
  </div>

  <!-- 📘 INFO PRINCIPAL -->
  <section class="info-section">

    <div class="info-block">
      <h3>■ OBJETIVO GENERAL</h3>
      <p>
        Formar profesionales con sentido humano y visión analítica e innovadora; con capacidad y habilidad de diseñar, construir y mantener sistemas ferroviarios, en un marco de desarrollo sostenible, con ética y compromiso social
      </p>
    </div>

      <div class="info-block">
      <h3>■ OBJETIVOS EDUCACIONALES </h3>
      <ul>
        <li>Formar ingenieros ferroviarios con conocimientos sólidos en diseño, construcción, operación y mantenimiento de sistemas ferroviarios.</li>
        <li>Desarrollar habilidades para la resolución de problemas técnicos en la industria ferroviaria, utilizando herramientas de simulación, análisis y optimización</li>
        <li>Fomentar el uso y adaptación de nuevas tecnologías en el sector ferroviario para mejorar la eficiencia y seguridad del transporte</li>
        <li>Promover la responsabilidad social y ambiental en el ejercicio profesional, asegurando el cumplimiento de normativas y buenas prácticas</li>
        <li>Impulsar el liderazgo y el trabajo en equipo para la gestión efectiva de proyectos ferroviarios.</li>
        <li>Desarrollar habilidades de comunicación efectiva y principios éticos en el ámbito profesional.</li>
      </ul>
    </div>

    <div class="info-block">
      <h3>■ MISIÓN</h3>
      <p>
      Formar ingenieros ferroviarios con un alto sentido de responsabilidad social y ambiental, capaces de diseñar, construir, operar y mantener sistemas ferroviarios de manera eficiente y sostenible. A través de una educación integral y de calidad, impulsamos el desarrollo de competencias tecnológicas, analíticas y de liderazgo, contribuyendo al crecimiento del sector ferroviario y al bienestar de la sociedad.
      </p>
    </div>

     <div class="info-block">
      <h3>■ VISIÓN</h3>
      <p>
      Ser un referente en la formación de profesionales en ingeniería ferroviaria en el Estado de Campeche y en el país, reconocidos por su excelencia académica, innovación tecnológica y compromiso con el desarrollo sustentable del sector ferroviario. Nos consolidamos como un programa educativo alineado con las tendencias globales del transporte ferroviario, contribuyendo al desarrollo económico y social de la región.
      </p>
    </div>

  </section>

  <!-- 🧠 TABS -->
  <div class="tabs-box">

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">
          1. Perfil de Ingreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">
          2. Perfil de Egreso
        </button>
      </li>

   <!--    <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">
          3. Acreditacion
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab4">
          4. Información del Personal
        </button>
      </li> -->
    </ul>

    <div class="tab-content">

      <!-- TAB 1 -->
      <div id="tab1" class="tab-pane fade show active">
     
        <p>Los aspirantes a la carrera de Ingeniería Ferroviaria deben contar con:</p>

        <ul>
          <li>Habilidad para el razonamiento lógico y numérico.</li>
          <li>Interés por la tecnología, innovación y el desarrollo de infraestructura ferroviaria.</li>
          <li>Capacidad de análisis y resolución de problemas</li>
          <li>Actitud proactiva y trabajo en equipo</li>
          <li>Compromiso con la seguridad, la sustentabilidad y el desarrollo social.</li>
          <li>Conciencia Ambiental y Sensibilidad hacia el entorno natural, fundamental para el desarrollo de proyectos sostenibles en la región</li>
        </ul>
      </div>

      <!-- TAB 2 -->
      <div id="tab2" class="tab-pane fade">
        
        <ul>
          <li>Planea, construye y controla procesos de instalación, actualización, operación y mantenimiento de los sistemas ferroviarios, conforme a la normatividad vigente considerando el impacto ambiental</li>
          <li>Resuelve problemas relacionados con la industria ferroviaria, utilizando herramientas matemáticas, técnicas de simulación y modelos de análisis, atendiendo necesidades sociales, actuales y emergentes</li>
          <li>Utiliza y adapta nuevas tecnologías para la mejora en los procesos de sistemas ferroviarios</li>
          <li>Emplea técnicas de control de calidad para optimizar el uso de los recursos en los sistemas ferroviarios</li>
          <li>Posee capacidad de trabajo en equipo y liderazgo que facilite la solución de problemas</li>
          <li>Desarrolla y ejecuta proyectos con responsabilidad social, sentido crítico y autocrítico</li>
          <li>Aplica principios éticos y se comunica de manera efectiva, transmitiendo sus ideas y conocimiento para la solución de problemas y desarrollo de proyectos</li>
        </ul>
      </div>

     
 <!--      <div id="tab3" class="tab-pane fade">
        <h4>Comité Mexicano de Acreditación de la Educación Agronómica, A.C. (29 enero 2021-28 enero 2026)</h4>
            <br>
           <div class="tab-image-wrapper">
            
          <img src="assets/banners_carreras/Logo COMEAA.jpg" alt="Información de la carrera" class="tab-image">
        </div> -->
        
 <!--      </div>

     
      <div id="tab4" class="tab-pane fade">
        <h5>Personal Responsable</h5>
        <p><strong>Nombre:</strong> Ing. Manuel de Atocha Barrancos Martínez</p>
        <p><strong>Correo:</strong> divisionisc@itsescarcega.edu.mx</p>
      </div> -->

    </div>
  </div>

  <!--DOCUMENTACIÓN -->
  <div class="doc-section text-center">
    <img src="assets/banners_carreras/logo_drive.png" class="doc-icon">
    <br>
    <a href="https://drive.google.com/drive/u/0/folders/1ju0oHEjho_rIi1eYPVtotysrrEPRX7n0" 
       target="_blank" 
       class="doc-link">
       ■ DOCUMENTACIÓN INGENIERÍA FERROVIARIA
    </a>
  </div>

  <hr>


  <div class="btn-section">

    <a href="assets/reticulas/Reticula IFER-2023-245.pdf" target="_blank" class="btn-doc">
      📊 Retícula
    </a>
  </div>

  <!-- CONTACTO  -->
  <section class="contact-section">

    <div class="contact-row">

      <div class="contact-card">
        <h3>■ JEFE DE DIVISIÓN</h3>
        <p class="name">Mtro. Gary G. Ucan Díaz</p>
        <p>E-mail: <a href="mailto:divisionif@itsescarcega.edu.mx">divisionif@itsescarcega.edu.mx</a></p>
        <P> Telefono:982 435 6770 </P>
      </div>
<!-- 
     <div class="contact-card">
        <h3>■ COORDINADORA</h3>
        <p class="name">Lic. Ana Dalia Antonio Ordoñez</p>
        <p>E-mail: <a href="mailto:coordinacionisc@itsescarcega.edu.mx">coordinacionisc@itsescarcega.edu.mx</a></p>
        <p> Telefono:9828291780</p>
      </div>  -->

    </div>

  </section>

</div>